<template>
  <div class="shipping_wrap bg_white mt12 pt16 pb16">
    <DeliverySelectBox
      :headTitle="'配達日指定'"
      :dataList="deliveryDateList"
      :keyMapper="{ value: 'deliveryDateValue', label: 'deliveryDateLabel' }"
      :initialValue="initialDeliveryDateValue"
      @update-data="handleDateUpdate"
    />
    <div class="mt24"></div>
    <DeliverySelectBox
      :headTitle="'配送時間指定'"
      :dataList="deliveryTimeList"
      :keyMapper="{ value: 'deliveryTimeId', label: 'deliveryTimeName' }"
      :initialValue="initialDeliveryTimeValue"
      @update-data="handleTimeUpdate"
    />

    <div class="shipping_address bdb mt24">
      <h2 class="content_title">配送住所</h2>


      <div class="address_detail right_arrow pl16 pr20 mt24 pb5" v-on:click="selectAddress()">
        <p class="shipping_name rb c5a">{{ delivaryAddressData.recipientName }}</p>
        <p class="address rr c5a"><span class="zip">〒{{ delivaryAddressData.zipCode }}</span> <span class="address_text">{{delivaryAddressData.prefectureName + delivaryAddressData.address }}</span></p>
      </div>
    </div>
    <!-- 配送先住所選択画面 -->
    <SelectAddress ref="openDeriveryAddress" @deliveryAddressData="sendAddress" />
  </div>
</template>

<script>
import SelectAddress from '@/components/purchase/SelectAddress';
import DeliverySelectBox from '@/components/purchase/DeliverySelectBox';

import scrollPosition from '@/model/scrollPosition';

export default {
  components: {
    SelectAddress,
    DeliverySelectBox
  },
  props: ['deliveryDateList', 'deliveryTimeList', 'initialDeliveryDateValue', 'initialDeliveryTimeValue'],
  data() {
    return {
      delivaryAddressData: {
        recipientName: '',
        deliveryAddressId: null,
        zipCode: '',
        prefectureName: '',
        address: ''
      },
    }
  },
  methods: {
    selectAddress() {
      scrollPosition.open();
      this.$refs.openDeriveryAddress.isShow();
    },

    sendAddress(data) {
      // console.log('sendAddress');
      this.delivaryAddressData.recipientName = data.recipientName
      this.delivaryAddressData.deliveryAddressId = data.deliveryAddressId;
      this.delivaryAddressData.zipCode = data.address.zipCode;
      this.delivaryAddressData.prefectureName = data.address.prefecture.prefectureName;
      this.delivaryAddressData.address = data.address.address;

      this.$emit('deliveryAddressData', this.delivaryAddressData);
    },
    handleDateUpdate(newDate) {
      this.$emit('update-date', newDate);
    },
    handleTimeUpdate(newTimeId) {
      this.$emit('update-time', newTimeId);
    }
  },
}
</script>

<style lang="css" scoped>
.content_title {
  width: 123px;
}
.shipping_time {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.shipping_time {
  border: none;
  font-size: 16px;
  width: 100%;
}

.right_arrow, .bottom_arrow {
  padding-right: 45px;
}

</style>



// WEBPACK FOOTER //
// src/components/purchase/Shipping.vue